import { TextPreset } from './Types'

export const TEXT_PRESETS: Array<TextPreset> = [
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291806/blaze_assets/designer/text_styles/pop-up_t1g1k9.png',
    props: {
      text: 'Pop-Up',
      color: '#FFFFFF',
      fontFamily: 'Pacifico',
      fontWeight: 400,
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291811/blaze_assets/designer/text_styles/hey_rnbtoq.png',
    props: {
      text: 'Hey!',
      fontFamily: 'Kavoon',
      fontWeight: 400,
      color: '#001FC0',
      strokeColor: '#ffffff',
      strokeWidth: 24,
      shadow: {
        color: '#000000',
        blur: 4,
        x: 0,
        y: 4,
        opacity: 0.15,
      },
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291814/blaze_assets/designer/text_styles/story_bzw41j.png',
    props: {
      text: 'Story',
      fontFamily: 'Merriweather',
      fontWeight: 400,
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291866/blaze_assets/designer/text_styles/offering_flfnz4.png',
    props: {
      text: 'Offering',
      fontFamily: 'Poppins',
      letterSpacing: -1,
      fontWeight: 600,
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291803/blaze_assets/designer/text_styles/from_hzo3nd.png',
    props: {
      text: 'From',
      fontFamily: 'Permanent Marker',
      fontWeight: 400,
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291808/blaze_assets/designer/text_styles/release_koggp0.png',
    props: {
      text: 'Release',
      fontFamily: 'Epilogue',
      fontWeight: 900,
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291817/blaze_assets/designer/text_styles/big-sale_veiw03.png',
    props: {
      text: 'Big Sale',
      fontFamily: 'Bebas Neue',
      fontWeight: 400,
      shadow: {
        color: '#000000',
        blur: 3,
        x: 0,
        y: 4,
        opacity: 0.16,
      },
      strokeWidth: 28,
      strokeColor: '#FFFB9C',
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291821/blaze_assets/designer/text_styles/edgy_zhircv.png',
    props: {
      text: 'Edgy',
      fontFamily: 'Dela Gothic One',
      fontWeight: 400,
      uppercase: true,
      color: '#FBFFC6',
      shadow: {
        color: '#000000',
        blur: 0,
        x: 4,
        y: 4,
        opacity: 0.25,
      },
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291824/blaze_assets/designer/text_styles/new_ax1zie.png',
    props: {
      text: 'New',
      fontFamily: 'Chelsea Market',
      fontWeight: 400,
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291827/blaze_assets/designer/text_styles/quick_g1wtqr.png',
    props: {
      text: 'Quick',
      fontFamily: 'Quicksand',
      uppercase: true,
      color: '#FFB6F7',
      fontWeight: 400,
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291831/blaze_assets/designer/text_styles/value_zzbnn5.png',
    props: {
      text: 'Value',
      fontFamily: 'Playball',
      fontWeight: 400,
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291834/blaze_assets/designer/text_styles/goods_qnt2wd.png',
    props: {
      text: 'Goods',
      fontFamily: 'Great Vibes',
      color: '#294A08',
      fontWeight: 400,
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291841/blaze_assets/designer/text_styles/rollin_akz4ei.png',
    props: {
      text: "Rollin'",
      fontFamily: 'Rock Salt',
      color: '#FFFFFF',
      fontWeight: 400,
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291845/blaze_assets/designer/text_styles/cart_tg37sa.png',
    props: {
      text: 'Cart',
      fontFamily: 'Gravitas One',
      color: '#4A542E',
      fontWeight: 400,
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291849/blaze_assets/designer/text_styles/glow_ic219f.png',
    props: {
      text: 'Glow',
      fontFamily: 'Bungee',
      color: '#FFFFFF',
      fontWeight: 400,
      shadow: {
        blur: 24,
        x: 0,
        y: 0,
        color: '#FFFFFF',
        opacity: 0.25,
      },
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291853/blaze_assets/designer/text_styles/item_jo3hf3.png',
    props: {
      text: 'Item',
      fontFamily: 'Playfair Display',
      fontWeight: 400,
      color: '#000000',
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291857/blaze_assets/designer/text_styles/yes_rqqs6u.png',
    props: {
      text: 'Yes!',
      fontFamily: 'Homemade Apple',
      color: '#C60000',
      fontWeight: 400,
    },
  },
  {
    preview:
      'https://res.cloudinary.com/almanac/image/upload/v1721291862/blaze_assets/designer/text_styles/deal_tg037w.png',
    props: {
      text: 'deal',
      fontFamily: 'Outfit',
      fontWeight: 400,
      color: '#000000',
    },
  },
]
